// Iter 104 — Extracted from SwipeCards.js verbatim.
import { useState, useEffect } from "react";
import axios from "axios";
import { hapticTap } from "../../utils/haptics";
import { f$, fN, fP, API } from "./_shared";
import { Skel } from "./Skel";

export function EliteExpanded() {
  const [tab, setTab] = useState("universe"); // "universe" | "entry"
  const [tkr, setTkr] = useState("SPY");
  // iter 94 — localStorage SWR for instant render.
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem("zi_elite_universe_v1");
      if (cached) {
        const { payload, ts } = JSON.parse(cached);
        if (Date.now() - ts < 600000) return payload;
      }
    } catch {}
    return null;
  });
  const [loading, setLoading] = useState(() => {
    try { return !localStorage.getItem("zi_elite_universe_v1"); } catch {}
    return true;
  });

  const load = async () => {
    try {
      if (tab === "universe") {
        const r = await axios.get(`${API}/elite/universe?max_per_ticker=2`);
        setData(r.data);
        try { localStorage.setItem("zi_elite_universe_v1", JSON.stringify({ payload: r.data, ts: Date.now() })); } catch {}
      } else {
        const r = await axios.get(`${API}/elite/entry/${tkr}?top_n=3`);
        setData(r.data);
      }
    } catch {
      if (!data) setData(null);
    }
    setLoading(false);
  };
  useEffect(() => {
    // Show loader only when switching to `entry` tab (no cache for per-ticker entry).
    if (tab === "entry") setLoading(true);
    load();
    // eslint-disable-next-line
  }, [tab, tkr]);

  const verdictColor = (v) => v === "elite" ? "#fbbf24" : v === "strong" ? "#4ade80" : v === "moderate" ? "#60a5fa" : "#8b949e";
  const confBarColor = (c) => c >= 75 ? "#fbbf24" : c >= 60 ? "#4ade80" : c >= 45 ? "#60a5fa" : "#8b949e";

  const PickRow = ({ p }) => (
    <div data-testid={`elite-pick-${p.ticker || tkr}-${p.side}-${p.strike}`} style={{ padding: 12, borderRadius: 12, background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)", marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: "#e6edf3" }}>
            {p.ticker || tkr} · <span style={{ color: p.side === "call" ? "#4ade80" : "#f87171" }}>${p.strike} {p.side?.toUpperCase()}</span>
          </div>
          <div style={{ fontSize: 10, color: "#8b949e", marginTop: 2 }}>
            DTE {p.dte} · IV {(p.iv * 100).toFixed(0)}% · Spot ${p.spot} · BE ${p.breakeven}
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: confBarColor(p.confidence), lineHeight: 1 }}>{p.confidence}</div>
          <div style={{ fontSize: 9, fontWeight: 700, color: verdictColor(p.verdict), letterSpacing: 1.5, textTransform: "uppercase", marginTop: 2 }}>{p.verdict}</div>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6, margin: "10px 0" }}>
        <div><div style={{ fontSize: 8, color: "#636e7b", letterSpacing: 1, textTransform: "uppercase" }}>PoP</div><div style={{ fontSize: 12, fontWeight: 700, color: "#e6edf3" }}>{(p.pop_blend * 100).toFixed(0)}%</div></div>
        <div><div style={{ fontSize: 8, color: "#636e7b", letterSpacing: 1, textTransform: "uppercase" }}>EV</div><div style={{ fontSize: 12, fontWeight: 700, color: p.realistic_ev >= 0 ? "#4ade80" : "#f87171" }}>${p.realistic_ev}</div></div>
        <div><div style={{ fontSize: 8, color: "#636e7b", letterSpacing: 1, textTransform: "uppercase" }}>Liq</div><div style={{ fontSize: 12, fontWeight: 700, color: "#e6edf3" }}>{p.liquidity_score}</div></div>
        <div><div style={{ fontSize: 8, color: "#636e7b", letterSpacing: 1, textTransform: "uppercase" }}>Safe</div><div style={{ fontSize: 12, fontWeight: 700, color: "#e6edf3" }}>{p.safety_score}</div></div>
      </div>
      <div style={{ display: "flex", gap: 2, height: 4, borderRadius: 2, overflow: "hidden", marginBottom: 6 }}>
        {Object.entries(p.breakdown || {}).map(([k, v]) => (
          <div key={k} title={`${k.replace(/_/g,' ')}: ${v}`} style={{ flex: 1, background: confBarColor(v), opacity: 0.85 }} />
        ))}
      </div>
      <div style={{ fontSize: 9, color: "#636e7b" }}>Kelly {p.kelly?.contracts || 0} contracts · ${p.kelly?.capital_at_risk || 0} at risk</div>
    </div>
  );

  return (
    <div style={{ padding: "0 16px 32px" }} data-testid="elite-expanded">
      <div style={{ textAlign: "center", marginBottom: 14 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: "#fef08a", letterSpacing: -0.4 }}>Elite Picks</div>
        <div style={{ fontSize: 11, color: "#8b949e", marginTop: 4 }}>Omega-ranked contracts by probabilistic edge</div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        {["universe", "entry"].map(t => (
          <button
            key={t}
            data-testid={`elite-tab-${t}`}
            onClick={() => { hapticTap(); setTab(t); }}
            style={{
              flex: 1, padding: "8px 12px", borderRadius: 10, fontSize: 11, fontWeight: 700, letterSpacing: 1,
              textTransform: "uppercase", cursor: "pointer", border: "1px solid",
              borderColor: tab === t ? "#fde047" : "rgba(255,255,255,0.08)",
              background: tab === t ? "rgba(253,224,71,0.15)" : "rgba(255,255,255,0.03)",
              color: tab === t ? "#fde047" : "#8b949e",
            }}
          >{t === "universe" ? "Universe" : `Entry · ${tkr}`}</button>
        ))}
      </div>

      {/* Ticker input for entry mode */}
      {tab === "entry" && (
        <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
          {["SPY", "QQQ", "AAPL", "NVDA", "TSLA", "F", "CMG"].map(t => (
            <button
              key={t}
              data-testid={`elite-ticker-${t}`}
              onClick={() => { hapticTap(); setTkr(t); }}
              style={{
                flex: 1, padding: "6px 4px", borderRadius: 8, fontSize: 10, fontWeight: 700,
                cursor: "pointer", border: "1px solid",
                borderColor: tkr === t ? "#60a5fa" : "rgba(255,255,255,0.08)",
                background: tkr === t ? "rgba(96,165,250,0.15)" : "rgba(255,255,255,0.03)",
                color: tkr === t ? "#60a5fa" : "#8b949e",
              }}
            >{t}</button>
          ))}
        </div>
      )}

      {loading && <div data-testid="elite-loading"><Skel w="100%" h={100} mb={10} radius={12} /><Skel w="100%" h={100} mb={10} radius={12} /><Skel w="100%" h={100} mb={0} radius={12} /></div>}

      {!loading && tab === "entry" && data?.picks?.length > 0 && (
        <>
          <div style={{ fontSize: 10, color: "#8b949e", marginBottom: 10 }}>
            {data.ticker} · spot ${data.spot} · evaluated {data.total_scored} contracts · capital ${data.capital}
          </div>
          {data.picks.map((p, i) => <PickRow key={i} p={{ ...p, ticker: data.ticker }} />)}
        </>
      )}
      {!loading && tab === "entry" && (!data?.picks || data.picks.length === 0) && (
        <div style={{ padding: 24, textAlign: "center", fontSize: 12, color: "#8b949e" }}>
          No qualifying contracts for {tkr} right now. Try another ticker.
        </div>
      )}

      {!loading && tab === "universe" && data?.tiers && (
        <>
          <div style={{ fontSize: 10, color: "#8b949e", marginBottom: 10 }}>
            {data.total_evaluated} contracts evaluated across all tiers · capital ${data.capital}
          </div>
          {Object.entries(data.tierMeta || {}).map(([name, meta]) => {
            const picks = data.tiers[name] || [];
            if (picks.length === 0) return null;
            return (
              <div key={name} data-testid={`elite-tier-${name}`} style={{ marginBottom: 18 }}>
                <div style={{ fontSize: 10, color: "#fde047", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>
                  {meta.label} · {picks.length}
                </div>
                {picks.map((p, i) => <PickRow key={`${name}-${i}`} p={p} />)}
              </div>
            );
          })}
          {data.total_evaluated === 0 && (
            <div style={{ padding: 24, textAlign: "center", fontSize: 12, color: "#8b949e" }}>
              No universe data yet. Watchlist scan is warming up.
            </div>
          )}
        </>
      )}
    </div>
  );
}
